'use client';

import { useEffect } from 'react';
import { useWebSocketStore } from '@/stores/websocket-store';

/**
 * Hook to manage WebSocket connection lifecycle.
 *
 * Connects on mount, disconnects on unmount.
 * WebSocket sends cookies automatically (same-origin via Next.js rewrites / Nginx proxy),
 * so no explicit session token is needed from the frontend.
 *
 * The backend WebSocket endpoint validates session_id from query params.
 * In production, the Nginx proxy or Next.js middleware can forward the session cookie
 * as a query param. For simplicity, we connect without query params and rely on
 * the same-origin cookie being available to the backend.
 */
export function useWebSocket() {
  const isConnected = useWebSocketStore((s) => s.isConnected);
  const newTrends = useWebSocketStore((s) => s.newTrends);
  const connect = useWebSocketStore((s) => s.connect);
  const disconnect = useWebSocketStore((s) => s.disconnect);
  const clearNewTrends = useWebSocketStore((s) => s.clearNewTrends);

  useEffect(() => {
    connect();
    return () => {
      disconnect();
    };
  }, [connect, disconnect]);

  return { isConnected, newTrends, clearNewTrends };
}
